import { useScrollCarousel } from "../../hooks/useScrollCarousel";
import { StoreCarouselNav } from "../StoreCarouselNav";
import { StoreStars } from "../StoreStars";
import styles from "./styles.module.scss";

const testimonials = [
  { name: "Jhonatas Vieira", text: "Eu estava quase careca e, em poucos meses, recuperei o cabelo. Hoje me sinto muito mais confiante." },
  { name: "Luis Eduardo", text: "Depois de tentar vários outros tratamentos, finalmente vi resultados reais. Superou minhas expectativas." },
  { name: "Hugo Rodrigues", text: "Nunca usei nada que me desse resultados tão visíveis. Meu cabelo está mais forte, mais cheio e mais brilhante. Produto incrível, recomendo!" },
];

export function StoreTestimonials() {
  const { trackRef, prev, next } = useScrollCarousel<HTMLUListElement>();

  return (
    <section className={styles.section} aria-labelledby="store-testimonials-title">
      <div className={styles.inner}>
        <span className={styles.eyebrow}>Depoimentos</span>
        <h2 className={styles.title} id="store-testimonials-title">Milhares de pacientes já usaram e aprovaram</h2>

        <ul className={styles.track} ref={trackRef}>
          {testimonials.map((testimonial) => (
            <li className={styles.card} key={testimonial.name}>
              <StoreStars tone="brown" />
              <p className={styles.text}>{testimonial.text}</p>
              <span className={styles.name}>{testimonial.name}</span>
            </li>
          ))}
        </ul>
        <StoreCarouselNav label="Depoimentos" onPrev={prev} onNext={next} />
      </div>
    </section>
  );
}
